isUrl = require('is-url')

module.exports = ()->
  return {
    template: require('./display-item.html')
    scope: { item: '=displayItem' }
    controller: ( $scope ) ->
      $scope.getItemType = ( item ) ->
        if isUrl(item)
          return "url"
        return undefined
  }
